// NAVIGATION MODULES
export enum UserModuleNameTypes {
  DASHBOARD = "DASHBOARD",
  RECORDINGRULES = "RECORDINGRULES",
  INQUIRIES = "INQUIRIES",
  PENDING_FOLLOWUP = "PENDING_FOLLOWUP",
  BATCHES = "BATCH",
  FINANCE = "FINANCE",
  MANAGEMENTSADMINS = "MANAGEMENTSADMINS",
  EXPENSES = "EXPENSES",
  CONFIGURATION = "CONFIGURATION",
  MARKETING = "MARKETING",
  TRAINER = "TRAINER",
  STUDENT = "STUDENT",
  USER = "USER",
  ROLES = "ROLES",
  TRANSACTIONS = "TRANSACTIONS",
  MODES = "MODES",
  DISPOSITION = "DISPOSITION",
  LOCATIONS = "LOCATIONS",
  BRANCHES = "BRANCHES",
  COURSES = "COURSES",
  CHAPTERS = "CHAPTERS",
  MODULES = "MODULES",
  EXPENSE_CATEGORIES = "EXPENSE_CATEGORIES",
  ACCOUNTS = "ACCOUNTS",
  HOLIDAY_CALENDAR = "HOLIDAY_CALENDAR",
  LANGUAGE = "LANGUAGE",
  COMMUNICATION_METHOD = "COMMUNICATION_METHOD",
  COUPONS = "COUPONS",
  CHANNEL = "CHANNEL",
  CAMPAIGN_GROUP = "CAMPAIGN_GROUP",
  CAMPAIGN = "CAMPAIGN",
  QUESTION = "QUESTION",
  RESOURCE = "RESOURCE",
  ASSETS = "ASSETS",
  REGISTRATION_LINKS = "REGISTRATION_LINKS",
  REGISTRATION_REQUESTS = "REGISTRATION_REQUESTS",
  REGISTRATION = "REGISTRATION",
  UPCOMEING_PAYMENTS = "UPCOMEING_PAYMENTS",
  GOAL_CATEGORY = "GOAL_CATEGORY",
  GOAL = "GOAL",
  GOAL_CONFIGURATION = "GOAL_CONFIGURATION",
  WEBSITE_CONTENT = "WEBSITE_CONTENT",
  JOB_BOARD = "JOB_BOARD",
  TESTIMONIALS = "TESTIMONIALS",
  BLOGS = "BLOGS",
  TEST_MODULE = "TEST_MODULE",
  QUESTION_CATEGORY = "QUESTION_CATEGORY",
  QUESTION_TECHNOLOGY = "QUESTION_TECHNOLOGY",
  TEST_QUESTION = "TEST_QUESTION",
  TEST_SERIES = "TEST_SERIES",
  TEST_CHECK = "TEST_CHECK",
  TEST_ASSIGN = "TEST_ASSIGN",
}
// MODULE ACTIONS
export enum UserModuleActionTypes {
  EDIT = "EDIT",
  CHANGE_STATUS = "CHANGE_STATUS",
  APPROVE = "APPROVE",
  MARK_AS_SPAM = "MARK_AS_SPAM",
  STUDENT_PASSWORD_CHANGE = "STUDENT_PASSWORD_CHANGE",
  TRAINER_PASSWORD_CHANGE = "TRAINER_PASSWORD_CHANGE",
  ADD_QUICK_INQUIRIE = "ADD_QUICK_INQUIRIE",
  DELETE = "DELETE",
  VIEW = "VIEW",
  LIST = "LIST",
  ADD = "ADD",
  DISPOSITION_ONE_ADD = "DISPOSITION_ONE_ADD",
  DISPOSITION_TWO_ADD = "DISPOSITION_TWO_ADD",
  CITY_ADD = "CITY_ADD",
  STATE_ADD = "STATE_ADD",
  COUNTRY_ADD = "COUNTRY_ADD",
  INQUIRIES_EDIT_DETAILS = "INQUIRIES_EDIT_DETAILS",
  INQUIRIES_EDIT_FOLLOWUP = "INQUIRIES_EDIT_FOLLOWUP",
  INQUIRIES_EDIT_FOLLOWUP_EDIT = "INQUIRIES_EDIT_FOLLOWUP_EDIT",
  INQUIRIES_EDIT_FOLLOWUP_ADD = "INQUIRIES_EDIT_FOLLOWUP_ADD",
  INQUIRIES_EDIT_FOLLOWUP_LIST = "INQUIRIES_EDIT_FOLLOWUP_LIST",
  BATCHES_STUDENTS = "BATCHES_STUDENTS",
  BATCHES_ASSIGNMENTS = "BATCHES_ASSIGNMENTS",
  BATCHES_ATTENDANCE = "BATCHES_ATTENDANCE",
  BATCHES_STUDENTS_LIST = "BATCHES_STUDENTS_LIST",
  BATCHES_ASSIGNMENTS_ADD = "BATCHES_ASSIGNMENTS_ADD",
  BATCHES_ATTENDANCE_LIST = "BATCHES_ATTENDANCE_LIST",
  BATCHES_LECTURE_NOTES = "BATCHES_LECTURE_NOTES",
  BATCHES_LECTURE_NOTES_LIST = "BATCHES_LECTURE_NOTES_LIST",
  BATCHES_RECORDINGS_AND_NOTES = "BATCHES_RECORDINGS_AND_NOTES",
  BATCHES_RECORDINGS_AND_NOTES_LIST = "BATCHES_RECORDINGS_AND_NOTES_LIST",
}

// MODULE OTHER ACTIONS
export enum UserModuleOtherActionTypes {}
